import React, { useEffect, useRef } from "react";
import useOutsideClick from "./Hooks/useOutsideClick";

const Dialog = ({ setOpen, dialogClasses = "", children }) => {
  const dialogRef = useRef();
  useOutsideClick(dialogRef, () => setOpen(false));

  return (
    <div
      ref={dialogRef}
      className={`dialog__container ${dialogClasses}`}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  );
};

export const DialogHeader = ({ children }) => {
  return <div className="dialog__header">{children}</div>;
};

export const DialogOptions = ({ children }) => {
  return <div className="dialog__body">{children}</div>;
};

export default Dialog;
